import React, { useContext, useState } from 'react'
import * as R from 'ramda'
import styled, { ThemeProvider } from 'styled-components'
import Modal from 'react-modal'
import { Helmet } from 'react-helmet'
import Check from '../../assets/svgs/Check.js'
import Button from '../../components/Button'
import Checkbox from '../../components/Checkbox'
import InputCode from '../../components/InputCode'

import { objInfomationsTable, objPrices } from '../../constants/SectionHome'
import IconClose from '../../assets/images/icon-close.png'

import { AppContext } from '../../store'

const pickColor = (option) => R.path(['theme', `color_${option}`])

const Container = styled.div`
  .section-home-container div.title-container {
    color: ${pickColor('label_on_primary')};
  }
  .btn.secondary {
    background: ${pickColor('button')};
    color: ${pickColor('button_label')};
  }
  .text-container {
    color: ${pickColor('primary')};
  }

  .text-secondary {
    color: ${pickColor('default')};
  }

  .section-home-container.gray {
    background: ${pickColor('secondary')};
  }

  .section-home-container.pt0 {
    background: ${pickColor('primary')};
  }

  .plans-container,
  .code-input-container {
    .btn.secondary {
      background: ${pickColor('default')};
      color: #fff;
    }
  }
`
const SectionHomeContainer = styled.div`
  background: ${pickColor('primary')};
`

export default function SectionHomeDesktop() {
  const { state, openPromotion } = useContext(AppContext)
  const { isHUB, ready, mainBonus, regulamento, loading, contentful } = state

  const { team: { fields = {} } = {} } = contentful || {}

  const [checkTerm, setCheckTerm] = useState(false)
  const [checkTerm2, setCheckTerm2] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const disableBtn = () => {
    setCheckTerm(!checkTerm)
  }

  const disableBtn2 = () => {
    setCheckTerm2(!checkTerm2)
  }

  const showModalTerm = () => {
    document.body.style.overflow = 'hidden'
    setModalIsOpen(!modalIsOpen)
  }

  const closeModalTerm = () => {
    document.body.style.overflow = 'auto'
    setModalIsOpen(false)
  }

  const toPlans = () => {
    document.getElementById('home').scrollIntoView()
  }

  const customStyles = {
    content: {},
  }

  const banner = (
    <div className='title-container'>
      <div className='title-container--content'>
        <h1>
          <strong>{fields.panel_primary_call_title}</strong>
        </h1>
        <p>{fields.panel_primary_call_description}</p>
        <button className='btn secondary cta' onClick={toPlans}>
          {fields.panel_primary_call_button_label}
        </button>
      </div>
      <div className='image-container'>
        <img src={fields.panel_primary_call_image?.fields?.file?.url} alt='car' />
      </div>
    </div>
  )

  const canonicalHref = `https://veloe.com.br/${(fields.team || '').toLowerCase()}`

  const links = {
    link: [
      {
        rel: 'canonical',
        href: canonicalHref,
      },
    ],
  }

  const meta = [
    { name: 'theme-color', content: fields.color_primary },

    // Facebook
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: canonicalHref },

    // Twitter
    { property: 'twitter:card', content: 'website' },
    { property: 'twitter:url', content: canonicalHref }
  ]

  return (
    <ThemeProvider theme={fields}>
      <Helmet meta={meta} {...links} />
      <Container>
        <SectionHomeContainer className='section-home-container pb0 pt0'>
          <section className='content-container'>{banner}</section>
        </SectionHomeContainer>
        {isHUB && !ready && (
          <section id='home' className='section-home-container gray'>
            <section className='content-container'>
              <InputCode />
            </section>
          </section>
        )}
        <section className={`section-home-container ${ready ? 'pt0' : 'pb0 pt0'}`}>
          <section className='content-container'>
            {!loading && ready && (
              <div id='home' className='plans-container'>
                <div className='container-title'>
                  <div className='logo-container'>
                    <img className='logo' alt='Carro' src={fields.painel_plan_image?.fields?.file?.url} />
                  </div>
                  <div className='text-container'>
                    <h1>{fields.painel_plan_title}</h1>
                  </div>
                </div>
                <table>
                  <tr id='home'>
                    {objInfomationsTable.map(
                      ({ title, classBlock, classTitle, subtitle, paragraph1, classParagraph2, paragraph2 }) => {
                        return (
                          <th className={`infomation calibri ${classBlock}`}>
                            {title && <div className={classTitle}>{title}</div>}

                            {subtitle && <div className='subtitle'>{subtitle}</div>}

                            {paragraph1 && <div className='paragraph mb10'>{paragraph1}</div>}

                            {paragraph2 && (
                              <div className={`${classParagraph2 && classParagraph2} paragraph`}>{paragraph2}</div>
                            )}
                          </th>
                        )
                      }
                    )}
                  </tr>
                </table>

                <hr className='divider' />

                <table>
                  <tr>
                    <th className='calibri text-initial bold'>Tempo de isenção</th>
                    <th className='calibri bold'>{mainBonus} mensalidades grátis</th>
                    <th className='calibri bold'>{mainBonus} mensalidades grátis</th>
                  </tr>
                  {objPrices.map(({ title, information1, information2, classPrice }) => (
                    <tr className='calibri'>
                      <td className={`title calibri f18 ${classPrice ? classPrice : ''}`}>{title}</td>
                      <td name='TaxaAdesaoPre' className={`tc calibri f18 ${classPrice ? classPrice : ''}`}>
                        {information1 === 'Check' ? <Check /> : information1}
                      </td>
                      <td name='TaxaAdesaoPos' className={`tc ${classPrice ? classPrice : ''}`}>
                        {information2 === 'Check' ? <Check /> : information2}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td className={`title bold calibri`}>Mensalidade após {mainBonus} meses</td>
                    <td name='MensalidadePre' className={`tc bold calibri`}>
                      R$ 18,90
                    </td>
                    <td name='MensalidadePos' className={`tc bold calibri`}>
                      R$ 20,90
                    </td>
                  </tr>

                  <tr>
                    <th></th>
                    <th>
                      <div className='checkbox-container'>
                        <Checkbox name='checkboxPre' onChange={disableBtn} />
                        <span>
                          Estou ciente que, ao prosseguir, aceito os{' '}
                          <span className='underline' onClick={showModalTerm}>
                            termos e condições
                          </span>{' '}
                          da campanha
                        </span>
                      </div>
                      <div>
                        <Button
                          className='secondary'
                          onClick={openPromotion('PRE')}
                          text='Quero Pré-Pago'
                          disabled={!checkTerm}
                        />
                      </div>
                    </th>
                    <th>
                      <div className='checkbox-container'>
                        <Checkbox name='checkboxPos' onChange={disableBtn2} />
                        <span>
                          Estou ciente que, ao prosseguir, aceito os{' '}
                          <span className='underline' onClick={showModalTerm}>
                            termos e condições da campanha
                          </span>
                        </span>
                      </div>
                      <div>
                        <Button
                          className='secondary'
                          onClick={openPromotion('POS')}
                          text='Quero Pós-Pago'
                          disabled={!checkTerm2}
                        />
                      </div>
                    </th>
                  </tr>
                </table>
              </div>
            )}
          </section>
        </section>
        <Modal isOpen={modalIsOpen} onRequestClose={closeModalTerm} style={customStyles} contentLabel='Example Modal'>
          <div className='modal-desk'>
            <div className='modal-header'>
              <button className='btn-close' onClick={closeModalTerm}>
                <img alt='Icon Close' src={IconClose} />
              </button>
            </div>
            <div className='title' style={{ textAlign: 'center' }}>
              <h3>{regulamento.title.toUpperCase()}</h3>
            </div>
            <div className='modal-container calibri' dangerouslySetInnerHTML={{ __html: regulamento.content }} />
          </div>
        </Modal>
      </Container>
    </ThemeProvider>
  )
}
